import { render, staticRenderFns } from "./WizardSteps.vue?vue&type=template&id=d5a530b4&"
import script from "./WizardSteps.vue?vue&type=script&lang=ts&"
export * from "./WizardSteps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports